const getDashboardMenu = (user) => {
  const userRole = user?.acc_type; // "admin", "user", etc.

  const baseMenu = [
    {
      label: "Tableau de bord",
      link: "/dashboard/analytics",
      icon: "ri-dashboard-line",
      roles: ['business'] // Rôles autorisés
    },
    {
      label: "Statistiques",
      link: "/dashboard/finance",
      icon: "ri-bar-chart-line",
      roles: ['admin', 'business']
    },
    {
      label: "Entités",
      link: "/apps/Entites",
      icon: "ri-home-line",
      roles: ['admin']
    },
    {
      label: "Alertes des tables",
      icon: "ri-notification-line",
      roles: ['admin'],
      submenu: [
        { label: "Alertes envoyées", link: "/apps/AlertesEnvoyees", roles: ['admin'] },
        { label: "Alertes soldes", link: "/apps/AlertesSoldes", roles: ['admin'] },
      ]
    },
    {
      label: "Messagerie",
      icon: "ri-mail-line",
      roles: ['admin', 'business'],
      submenu: [
        { label: "Historique", link: "/apps/HistoriqueMessages", roles: ['admin', 'business'] },
        { label: "Envoyer", link: "/apps/Envoie", roles: ['business'] },
        { label: "Envoi en masse", link: "/apps/EnvoieMasseHome", roles: ['business'] }, // Admin seulement
        { label: "Modèles en cours", link: "/apps/PendingModel", roles: ['admin', 'business'] },
      ]
    },
    {
      label: "Liste des contacts",
      icon: "ri-contacts-line",
      roles: ['admin', 'business'],
      submenu: [
        { label: "Liste des contacts", link: "/apps/ListeContacts", roles: ['admin', 'business'] },
        { label: "Groupes", link: "/apps/Group", roles: ['admin', 'business'] },
        { label: "Importer", link: "/apps/ImportContact", roles: ['business'] }, // Admin seulement
        { label: "Liste des stops", link: "/apps/ListeStops", roles: ['admin', 'business'] }
      ]
    },
    {
      label: "Modèles de messages",
      link: "/apps/Models",
      icon: "ri-file-list-3-line",
      roles: ['business']
    },

    {
      label: "Paiements",
      icon: "ri-currency-line",
      roles: ['admin', 'business'],
      submenu: [
        { label: "Nos tarifs", link: "/apps/Tarifs", roles: ['admin', 'business'] },
        { label: "Recharger", link: "/apps/Recharge", roles: ['business'] }, // Admin seulement
        { label: "Historique paiements", link: "/apps/HistoriquePaiement", roles: ['admin','business'] } // Admin seulement
      ]
    },

    {
      label: "Sender ID",
      link: "/apps/SenderID",
      icon: "ri-user-2-line",
      roles: ['admin','business']
    },

    {
      label: "Paramètres",
      icon: "ri-settings-3-line",
      roles: ['business'], // Admin seulement
      submenu: [
        // { label: "Sender ID", link: "/apps/SenderID", roles: ['admin','business'] },
        { label: "Enregistrer seuil", link: "/apps/enregistrerSeuil", roles: ['business'] },
        // { label: "Alertes", link: "/apps/alertes", roles: ['admin'] }
      ]
    },
    {
      label: "Développeurs",
      icon: "ri-tools-line",
      roles: ['admin','business'], // Admin seulement
      submenu: [
        { label: "Regénerer token", link: "/apps/regenererToken", roles: ['business'] },
        { label: "WebHooks", link: "/apps/WebHooks", roles: ['business'] },
        { label: "Documentation", link: "/apps/Documentation", roles: ['business'] }
      ]
    },

    {
      label: "Gestion GSM",
      icon: "ri-sim-card-2-line",
      roles: ['admin'],
      submenu: [
        { label: "Passerelles", link: "/apps/GsmPasserelles", roles: ['admin'] },
        { label: "Affectations clients", link: "/apps/GsmAffectations", roles: ['admin'] },
        { label: "Historique SMS", link: "/apps/GsmHistoriqueSms", roles: ['admin'] },
      ]
    },

    // ✅ AJOUT : Menu Logs - UNIQUEMENT ADMIN
    {
      label: "Logs système",
      icon: "ri-file-list-2-line",
      link: "/apps/Logs",
      roles: ['admin'],
     
    }
  ];

  // Fonction pour vérifier si l'utilisateur a le rôle requis
  const hasRole = (requiredRoles) => {
    if (!requiredRoles || requiredRoles.length === 0) return true;
    return requiredRoles.includes(userRole);
  };

  // Filtrer le menu selon le rôle de l'utilisateur
  return baseMenu.filter(item => hasRole(item.roles))
    .map(item => {
      // Filtrer aussi les sous-menus
      if (item.submenu) {
        return {
          ...item,
          submenu: item.submenu.filter(subItem => hasRole(subItem.roles))
        };
      }
      return item;
    })
    .filter(item => {
      // Supprimer les items sans sous-menu si c'est un menu déroulant
      if (item.submenu && item.submenu.length === 0) return false;
      return true;
    });
};

// const applicationsMenu = [
//   // {
//   //   label: "AIDE",
//   //   link: "/apps/Aides",
//   //   icon: "ri-question-line"    // icône aide
//   // }
// ];

export { getDashboardMenu };